import {
  DeleteOutlined,
  EditFilled,
  EyeOutlined,
  MoreOutlined,
} from "@ant-design/icons";
import {
  Box,
  Card,
  CardMedia,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  Snackbar, Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from "@mui/material";
import dayjs from "dayjs";
import { useEffect, useRef, useState,forwardRef, useImperativeHandle } from "react";
import { useNotification } from "../../../hooks/useNotification.js";
import { JournalAPIService } from "../../../services/api/JournalAPIService";
import {
  API_ERROR_MESSAGE,
  API_SUCCESS_MESSAGE,
  DATE,
} from "../../../shared/constants";
import ConfirmationDialog from "../../common/ConfirmationDialog.js";
import ImageCardTemplateEdit from "./ImageCardTemplateEdit";
import ImageEditor from "../../../pages/Memory_journal/ImageEditor.js";
import info from "../../../assests/Images/info.png";
import info1 from "../../../assests/Images/info1.png";
import info2 from "../../../assests/Images/info2.png";
import info3 from "../../../assests/Images/info3.png";


import ActionMenu from "../../../pages/Extra/ActionMenu.js";
import html2canvas from "html2canvas";
import { toPng } from "html-to-image";
import DownloadBackdrop from "../../../pages/Memory_journal/DownloadBackdrop.js";
import { FFmpeg } from "@ffmpeg/ffmpeg";
import { isRealSafari } from "../../../shared/utils.js";

const ffmpeg = new FFmpeg();

const ImageCardTemplate = forwardRef((props,ref) => {
  const {
    journalId,
    author,
    imgSrc,
    text,
    date,
    borderColor = "#f72bb1",
    backgroundColor = "#007bff",
    imageBottomRight,
    imageBottomRightStyle,
    textColor,
    disableEye = false,
    editData = false,
    pageRefreshCallback,
    menuShow
  } = props;

  const [imageUrl, setImageUrl] = useState(imgSrc);
  const [showEye, setShowEye] = useState(false);
  const { notifyError, notifySuccess } = useNotification();
  const [open, setOpen] = useState(false);
  const [editMode, setEditOpen] = useState(editData);
  const [anchorEl, setAnchorEl] = useState(null);
  const textRef = useRef(null);
  const [isSingleLine, setIsSingleLine] = useState(true);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

  const [isEditorOpen, setIsEditorOpen] = useState(false);
  const [imageToEdit, setImageToEdit] = useState(null);
  const [imageId, setImageId] = useState(null);
  const cardRef = useRef(null);
  const [downloading, setDownloading] = useState(false);
  const [openInfo, setOpenInfo] = useState(false);
  const [snackData, setSnackData] = useState({
      show: false,
      message: "",
      type: "error",
    });
  const openMenu = Boolean(anchorEl);


  useImperativeHandle(ref, () => ({
    getCardElement: () => cardRef.current,
  }));

  const handleOpenEditor = (url, id) => {
    handleCloseDialog();
    setImageToEdit(url);
    setImageId(id);
    setIsEditorOpen(true);
  };

  const handleCloseEditor = () => {
    setIsEditorOpen(false);
    setImageToEdit(null);
    setImageId(null);
  };

  const handleMenuClick = (action) => {
    switch (action) {
      case "edit":
        handleEdit();
        break;
      case "delete":
        handleDelete();
        break;
      case "effect":
        handleOpenEditor(imageUrl, journalId);
        break;
      case "view":
        handleOpenDialog();
          break;
      case "save":
        handleDownloadImage();
        break;
      case "drag":
        console.log("Drag action triggered");
        // Optional: set some dragging state here
        break;
      default:
        break;
    }
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setShowEye(false);
  };

  const handleOpenDialog = () => setOpen(true);
  const handleCloseDialog = () => {
    setOpen(false);
    setEditOpen(false);
    setShowEye(false);
  };

  const handleEdit = () => {
    if (!disableEye) {
      setOpen(true);
    }
    setShowEye(false);
    setEditOpen(true);
  };

  const handleCancelDelete = () => {
    setConfirmDialogOpen(false);
  };

  const handleDelete = () => {
    handleCloseDialog();
    setConfirmDialogOpen(true);
  };

  const handleConfirmDelete = () => {
    setConfirmDialogOpen(false);

    JournalAPIService.journalDelete(journalId)
      .then((response) => {
        notifySuccess(
          response.message || API_SUCCESS_MESSAGE.DELETED_SUCCESSFULLY
        );
        pageRefreshCallback();
      })
      .catch((errResponse) => {
        notifyError(
          errResponse?.response?.data?.message ||
            API_ERROR_MESSAGE.INTERNAL_SERVER_ERROR
        );
      });
    handleCloseDialog();
  };

  useEffect(() => {
    const element = textRef.current;
    if (element) {
      const lineHeight = parseFloat(getComputedStyle(element).lineHeight);
      const height = element.clientHeight;

      // If height is more than 1.5x the lineHeight, we assume it's multiline
      if (height > lineHeight * 1.2) {
        setIsSingleLine(false);
      } else {
        setIsSingleLine(true);
      }
    }
  }, [text]);


  const preloadImage = (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous"; // Important if using CORS images
      img.onload = resolve;
      img.onerror = reject;
      img.src = url;
    });
  };

  const waitForImages = (container) => {
    const images = container.querySelectorAll("img");
    const promises = Array.from(images).map(
      (img) =>
        new Promise((resolve) => {
          if (img.complete) return resolve();
          img.onload = img.onerror = resolve;
        })
    );
    return Promise.all(promises);
  };

  const wait = (ms) => new Promise((res) => setTimeout(res, ms));
  const handleDownloadImage = async () => {
    if (!cardRef.current) return;

    const isVideo = /\.(mp4|webm|ogg|m4v|mov|avi|mkv|3gpp|3gp|3g2|hevc|h265)$/i.test(imageUrl);
    if (isVideo) {
      handleDownloadVideo();
      return;
    }

    if(isRealSafari()){
      console.log("safari browser")
    }
    else
    {
      console.log("not safari browser")
    }

    const wrapper = document.createElement("div");

    try {
      setDownloading(true);
      // await preloadImage(imageUrl);
      // Clone card DOM element for better isolation (optional)
      const clone = cardRef.current.cloneNode(true);
      const rect = cardRef.current.getBoundingClientRect();

      if(isRealSafari()){
        clone.style.margin = "0";
        clone.style.padding = "0";
        clone.style.boxShadow = "none";
        clone.style.background = "transparent";
        clone.style.borderRadius = "16px";
        wrapper.style.padding = "0px 0px 0px 4px";
      }
      else{
        wrapper.style.padding = "0px 0px 0px 4px";
      }


      // wrapper.setAttribute("data-download-wrapper", "true");

      wrapper.style.background = "transparent";
      wrapper.style.backgroundColor = "transparent";
      wrapper.style.display = "inline-block";
      wrapper.style.boxSizing = "content-box";
      wrapper.style.boxShadow = "none";
      wrapper.style.borderRadius="16px";
      wrapper.style.width = `${rect.width}px`;
      // wrapper.style.height = `${rect.height+10}px`;
      // wrapper.style.width = "200px";
// wrapper.style.height = "600px";
      wrapper.appendChild(clone);
      document.body.appendChild(wrapper);

      await wait(600);
      await new Promise((r) => setTimeout(r, 800));

      // await document.fonts.ready;
      // await waitForImages(wrapper);

      const dataUrl = await toPng(wrapper, {
        cacheBust: true,
        skipFonts:true,
        backgroundColor:"transparent",
        // pixelRatio: 2,
        style: {
          transform: "none",
          margin: "0",
          boxShadow:"none!important",
          borderRadius:"16px"
        },
        filter: (node) => node.className !== "no-screenshot",
      });

      const base64Length = dataUrl.length - "data:image/png;base64,".length;
      const sizeInBytes = Math.ceil((base64Length * 3) / 4);

      console.log("sizeInBytes", sizeInBytes);
      if (sizeInBytes < 80 * 1024) {
        // Retry if under 80KB
        wrapper.remove();
        return handleDownloadImage();
      }

      const hashCode = (str) => {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
          hash = (hash << 5) - hash + str.charCodeAt(i);
          hash |= 0;
        }
        return Math.abs(hash % 10000);
      };
      const shortCode = hashCode(journalId);

      const link = document.createElement("a");
      link.download = `IMG_${shortCode}.png`;
      link.href = dataUrl;
      link.click();
      // setSnackData({
      //           show: true,
      //           message:API_SUCCESS_MESSAGE.DOWNLOAD_REEL,
      //           type: "success",
      //         });

      notifySuccess(API_SUCCESS_MESSAGE.DOWNLOAD_REEL);

    } catch (error) {
      console.error("Download failed:", error);
      notifyError("Image download failed.");
    } finally {
      setDownloading(false);
      wrapper.remove();
      // STEP 4: Cleanup clone from DOM
      const appendedWrapper = document.body.querySelector("[data-download-wrapper='true']");
      if (appendedWrapper) appendedWrapper.remove();
    }
  };


  const isVideo =
    /\.(mp4|webm|ogg|m4v|mov|avi|mkv|3gpp|3gp|3g2|hevc|h265)$/i.test(imageUrl);

  const handleSave = (imageURL) => {

    const updatedUrl = `${imageURL}?t=${Date.now()}`;
    setImageUrl(updatedUrl);
    handleCloseEditor();
  };

  const generateVideoWithOverlay = async (overlayImage, backgroundVideo) => {

    try {
      if (!ffmpeg.loaded) await ffmpeg.load();

      const overlayArrayBuffer = await fetch(URL.createObjectURL(overlayImage)).then(res => res.arrayBuffer());
      const bgVideoArrayBuffer = await fetch(URL.createObjectURL(backgroundVideo)).then(res => res.arrayBuffer());

      await ffmpeg.writeFile("overlay.png", new Uint8Array(overlayArrayBuffer));
      await ffmpeg.writeFile("background.mp4", new Uint8Array(bgVideoArrayBuffer));

      // FFmpeg: overlay PNG onto video
      await ffmpeg.exec([
        "-i", "background.mp4",
        "-i", "overlay.png",
        "-filter_complex",
        "[0:v]scale=480:500[vid];[1:v]scale=520:720[bg];[bg][vid]overlay=(W-w)/2:(H-h)/2-60",
        "-c:v", "libx264",
        "-pix_fmt", "yuv420p",
        "-preset", "ultrafast",
        "output_overlay.mp4"
      ]);
      const data = await ffmpeg.readFile("output_overlay.mp4");
      const url = URL.createObjectURL(new Blob([data.buffer], { type: "video/mp4" }));
      // Auto-download the file
    const a = document.createElement("a");
    a.href = url;
    a.download = "Joy_Memory.mp4";
    document.body.appendChild(a);
    a.click();
    setOpenInfo(true);
    document.body.removeChild(a);

    // Optional: Revoke the URL after some time to free memory
    setTimeout(() => URL.revokeObjectURL(url), 1000);

      // setVideoUrl(url);
    } catch (error) {
      console.error("Error generating overlay video:", error);
    }
  };


  const handleDownloadVideo = async () => {
    if (!cardRef.current) return;

    try {
      setDownloading(true);

      const canvas = await html2canvas(cardRef.current, {
        useCORS: true,
        backgroundColor: "#ffffff",
        // scale: 3,
      });

      const dataUrl = canvas.toDataURL("image/png");
      const blob = await (await fetch(dataUrl)).blob();

      // Use your own video path here
      const backgroundVideo = await fetch(imageUrl).then(res => res.blob());; // put this in your public folder

      await generateVideoWithOverlay(blob, backgroundVideo);
    } catch (err) {
      console.error("Video generation failed:", err);
      notifyError("Video generation failed.");
    } finally {
      setDownloading(false);
    }
  };


  return (
    <>
    {menuShow &&
      <IconButton
        sx={{
          position: "absolute",
          top: 12,
          right: 12,
          color: "black",
          zIndex: 1001,
          width: { xs: "25px", sm: "30px", md: "30px" },
          height: { xs: "25px", sm: "30px", md: "30px" },
          "@media (max-width: 440px)": {
            height: "20px",
            width: "20px",
            top:12,
            right:10
          },
          // bgcolor: "#ffffffc9",
        }}
        // onClick={handleMenuClick}
      >
        <ActionMenu action={handleMenuClick} show={isVideo} drag={true} fullView={true}/>
      </IconButton>
    }
      <div ref={cardRef} style={{width:"97%",padding: "2px 0px",fontFamily:"Poppins, Arial, sans-serif"}}>
        <Card
          sx={{
            marginLeft:"-3px",
            width: {
              xs: disableEye ? "96%" : "99%",
              sm: disableEye ? "60%" : "99%",
              md: disableEye ? "60%" : "99%",
            },
            height: {
              xs: disableEye ? 300 : 252,
              sm: disableEye ? 375 : 340,
              md: disableEye ? 375 : 340,
            },
            "@media (max-width: 370px)": {
              height: disableEye ? 300 : 252,

            },
            "@media (min-width: 310px) and (max-width: 360px)": {
              height: 222,
            },

            borderRadius: 4,
            marginTop: {
              xs: disableEye ? "10%" : "0%",
              sm: disableEye ? "4%" : "0%",
              md: disableEye ? "4%" : "0%",
            },
            border: `4px solid ${borderColor}`,
            position: "relative",
            overflow: "visible",
            justifySelf: "center",
            bgcolor: backgroundColor || "#f9f9f9",
            boxShadow:"none",

          }}
        >
          <Box
            sx={{
              position: "relative",
              overflow: "hidden",
            }}
            onMouseEnter={() => setShowEye(true)}
            onMouseLeave={() => setShowEye(false)}
          >

            {/* {showEye && !disableEye && (
              <IconButton
                onClick={handleOpenDialog}
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  zIndex: 1000,
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "rgba(0,0,0,0.5)",
                  "&:hover": { backgroundColor: "rgba(0,0,0,0.5)" },
                  borderRadius: 0,
                }}
              >
                <EyeOutlined style={{ fontSize: 40, color: "white" }} />
              </IconButton>
            )} */}

            {/* {!isVideo &&
                      <IconButton
                            sx={{
                              position: "absolute",
                              top: 80,
                              right: 8,
                              color: "black",
                              zIndex: 1001,
                              width: { xs: "25px", sm: "27px", md: "27px" },
                              height: { xs: "25px", sm: "27px", md: "27px" },
                              bgcolor: "#ffffffc9",
                            }}
                            onClick={() =>
                              handleOpenEditor(imgSrc, journalId)
                            }
                          >
                            <img src={magicToolIcon} width="18px" height="18px"/>
                          </IconButton>
                        } */}
{!isVideo ?
  <Box
  className="imageRender"
  sx={{
    width: "100%",
    height: { xs: "175px", sm: "248px", md: "248px" },
    "@media (min-width: 310px) and (max-width: 360px)": {
      height: 160,
    },
    borderRadius: "12px 12px 0px 0px",
    overflow: "hidden",
    position: "relative",
    boxSizing: "border-box",
  }}
>
  <img
    src={imageUrl}
    crossOrigin="anonymous"
    alt="card-image"
    style={{
      width: "100%",
      height: "100%",
      objectFit: "cover",
      display: "block",          // 👈 removes bottom gap
      transform: "scale(1.001)", // 👈 tiny nudge to fix edge rounding issues
      transformOrigin: "center",
    }}
  />
</Box>


:

            <CardMedia
              component={isVideo ? "video" : "img"}
              image={imageUrl}
              alt="Uploaded"
              controls
              sx={{
                objectFit: isVideo ? "none" : "cover",
                width: "100%",
                height: { xs: "175px", sm: "248px", md: "248px" },
                "@media (min-width: 310px) and (max-width: 360px)": {
                  height: 160,
                },
                borderRadius: "12px 12px 0px 0px",
              }}
            />
}
          </Box>

          <Box
  sx={{
    bgcolor: backgroundColor,
    color: "white",
    borderRadius: "0px 0px 12px 12px",
    padding: "1px",
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingLeft: text?.length > 40 ? "0px" : "3px",
    paddingRight: text?.length > 40 ? "0px" : "3px",

    minHeight: {
      xs: editMode ? "100px" : "57px",
      sm: editMode ? "100px" : isSingleLine ? "70px" : "70px",
      md: editMode ? "100px" : isSingleLine ? "70px" : "70px",
    },
    "@media (min-width: 310px) and (max-width: 360px)": {
      minHeight: "42px",
    },
  }}
>
  <Typography
    ref={textRef}
    variant="body1"
    sx={{
      fontWeight: 500,
      fontSize: {
        xs: text?.length > 50 ? "0.7rem" : "0.7rem",
        sm: "0.9rem",
        md: "0.9rem",
      },
      color: textColor,
      paddingLeft: "3px",
      paddingRight: "3px",
    }}
  >
    {text}
  </Typography>
</Box>

          <Typography
            sx={{
              position: "absolute",
              bottom: 4,
              left: "50%",
              transform: "translateX(-50%)",
              fontSize: { xs: "0.7rem", sm: "0.9rem", md: "0.9rem" },
              color: textColor,
            }}
          >
            {dayjs(date).format(DATE.JOURNAL_FORMAT)}
          </Typography>

          {imageBottomRight && (
            <Box
              component="img"
              src={imageBottomRight}
              alt="bottom-right"
              sx={{
                position: "absolute",
                bottom: 5,
                right: 5,
                borderRadius: "50%",
                ...imageBottomRightStyle,
              }}
            />
          )}
        </Card>

        <ConfirmationDialog
          id="confirmation-dialog-description"
          open={confirmDialogOpen}
          title=""
          description="Are you sure you want to delete this memory?"
          onConfirm={handleConfirmDelete}
          onCancel={handleCancelDelete}
          confirmText="Delete"
          cancelText="Cancel"
          keepMounted={false}
          transition="up"
          loading={false}
        />
        {open && (
          <ImageCardTemplateEdit
            open={open}
            onClose={handleCloseDialog}
            journalId={journalId}
            imgSrc={imageUrl}
            text={text}
            author={author}
            date={date}
            borderColor={borderColor}
            backgroundColor={backgroundColor}
            imageBottomRight={imageBottomRight}
            imageBottomRightStyle={imageBottomRightStyle}
            textColor={textColor}
            disableEye={true}
            editData={editMode}
            pageRefreshCallback={pageRefreshCallback}
            handleOpenEditor={handleOpenEditor}
          />
        )}

        {isEditorOpen && (
          <Dialog fullScreen open={isEditorOpen} sx={{ zIndex: 1001 }}>
            <ImageEditor
              imageUrl={imageToEdit}
              imageId={imageId}
              onClose={handleCloseEditor}
              onSave={handleSave}
            />
          </Dialog>
        )}
      </div>
      <DownloadBackdrop downloading={downloading} />

          <Snackbar
                  style={{ top: "80px" }}
                  anchorOrigin={{ vertical: "top", horizontal: "right" }}
                  open={snackData.show}
                  autoHideDuration={3000}
                  onClose={() => setSnackData({ show: false })}
                >
                  <Alert
                    onClose={() => setSnackData({ show: false })}
                    severity={snackData.type}
                  >
                    {snackData.message}
                  </Alert>
                </Snackbar>

                <Dialog open={openInfo} onClose={() => setOpenInfo(false)} sx={{zIndex:5000}}>
        <DialogTitle>📥 Find Your Download!</DialogTitle>
        <DialogContent>
  <Box sx={{ display: 'flex', alignItems: 'flex-start', mt: 1 }}>
    <Typography variant="body2" sx={{ fontWeight: 'bold', mr: 1 }}>1.</Typography>
    <Typography variant="body2">
      Look for the Download Icon ⬇️ in your browser address bar
    </Typography>
  </Box>

  <Box sx={{ display: 'flex', alignItems: 'flex-start', mt: 1 }}>
    <Typography variant="body2" sx={{ fontWeight: 'bold', mr: 1 }}>2.</Typography>
    <Typography variant="body2">
      Tap the Icon to see a list of your recent downloads. 👉 Tap the downloaded file to open it, play it or save it to your photos
    </Typography>
  </Box>

  <Box sx={{ display: 'flex', alignItems: 'flex-start', mt: 1 }}>
    <Typography variant="body2" sx={{ fontWeight: 'bold', mr: 1 }}>3.</Typography>
    <Typography variant="body2">
      Don’t See the Icon? Tap the <img src={info1} alt="Aa" width="25px" loading="eager" /> or <img src={info2} width="25px" alt="download" loading="eager" /> button in Safari’s address bar → Select “Show Downloads”
    </Typography>
  </Box>
</DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenInfo(false)} variant="contained" sx={{color:"#ffffff", background:"#005cff"}}>Got it!</Button>
        </DialogActions>
      </Dialog>
    </>
  );
});

export default ImageCardTemplate;
